import { useEffect, useState } from 'react';

import { getTopContent, MainFilter } from '../services/topContent';

const LOADING_MAIN_FILTER: MainFilter = {
    name: 'Categorías',
    options: [],
    type: 'checkbox',
};

const withLabelsAsValues = (mainFilter: MainFilter): MainFilter => ({
    ...mainFilter,
    options: mainFilter.options.map((option) => ({
        ...option,
        value: option.label,
    })),
});

/**
 * Filtro principal del buscador: las categorías salen del `mainFilter` del
 * documento `top_content_portal_servicios` de Elasticsearch
 */
const useMainFilter = (): MainFilter => {
    const [mainFilter, setMainFilter] =
        useState<MainFilter>(LOADING_MAIN_FILTER);

    useEffect(() => {
        const controller = new AbortController();

        getTopContent(controller.signal).then((topContent) => {
            if (topContent?.mainFilter) {
                setMainFilter(withLabelsAsValues(topContent.mainFilter));
            }
        });

        return () => controller.abort();
    }, []);

    return mainFilter;
};

export default useMainFilter;
